import { OFFICE } from "../data/office";

const UPDATED = "outubro de 2026";

function Section({ title, children }) {
  return (
    <section className="mt-10">
      <h2 className="font-display text-2xl font-semibold text-cream sm:text-3xl">{title}</h2>
      <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-mist">{children}</div>
    </section>
  );
}

export default function Privacy() {
  return (
    <main data-testid="privacy-page" className="bg-navy-900 pt-[72px]">
      <article className="mx-auto max-w-3xl px-5 py-20 sm:px-8 sm:py-28">
        <p className="font-mono-meta text-[11px] uppercase tracking-[0.35em] text-gold-400">
          LGPD · Lei nº 13.709/2018
        </p>
        <h1 className="font-display mt-4 text-4xl font-medium leading-tight text-cream sm:text-5xl">
          Política de <em className="gold-text">privacidade</em>
        </h1>
        <p className="mt-4 text-sm text-mist/70">Última atualização: {UPDATED}</p>

        <Section title="1. Quem somos">
          <p>
            Este site pertence a <strong className="text-cream">{OFFICE.name}</strong>, responsável
            (controladora) pelos dados pessoais tratados por meio dele. Dúvidas sobre esta política ou
            sobre seus dados podem ser enviadas para{" "}
            <a href={`mailto:${OFFICE.email}`} className="text-gold-400 underline underline-offset-4">
              {OFFICE.email}
            </a>
            .
          </p>
        </Section>

        <Section title="2. Quais dados coletamos">
          <p>
            <strong className="text-cream">Dados que você informa:</strong> ao usar o formulário de
            atendimento, você pode informar nome, telefone, área do problema e um breve relato do caso.
            Esses dados <strong className="text-cream">não ficam guardados neste site</strong>: eles
            são reunidos em uma mensagem que você mesmo envia ao WhatsApp do escritório.
          </p>
          <p>
            <strong className="text-cream">Estatísticas de visita:</strong> usamos uma ferramenta de
            estatísticas que conta acessos e páginas visitadas de forma agregada, sem cookies e sem
            identificar quem visitou.
          </p>
        </Section>

        <Section title="3. Para que usamos">
          <p>
            Usamos os dados que você envia apenas para responder ao seu contato, entender a sua
            situação e agendar o atendimento. As estatísticas servem somente para melhorar o site.
          </p>
          <p>Não vendemos, alugamos ou cedemos seus dados para fins de publicidade.</p>
        </Section>

        <Section title="4. Base legal">
          <p>
            O tratamento se baseia no seu consentimento, dado ao marcar a caixa de concordância antes
            do envio, e na realização de procedimentos preliminares a uma eventual contratação
            solicitados por você (art. 7º, incisos I e V, da LGPD).
          </p>
        </Section>

        <Section title="5. Sigilo profissional">
          <p>
            Todas as informações compartilhadas com o escritório são tratadas com o sigilo
            profissional próprio da advocacia, nos termos do Estatuto da Advocacia e do Código de
            Ética e Disciplina da OAB.
          </p>
        </Section>

        <Section title="6. Serviços de terceiros">
          <p>
            Ao clicar nos botões de WhatsApp, Instagram, Facebook ou Google Maps, você é direcionado
            a serviços de outras empresas, que têm suas próprias políticas de privacidade. O site é
            hospedado pela Vercel.
          </p>
        </Section>

        <Section title="7. Por quanto tempo guardamos">
          <p>
            As conversas e documentos recebidos são mantidos pelo tempo necessário ao atendimento e,
            havendo contratação, pelo prazo exigido para o cumprimento de obrigações legais e para a
            defesa de direitos.
          </p>
        </Section>

        <Section title="8. Seus direitos">
          <p>
            Você pode, a qualquer momento, pedir confirmação de que tratamos seus dados, acesso,
            correção, eliminação, informações sobre compartilhamento e revogação do consentimento
            (art. 18 da LGPD). Basta escrever para{" "}
            <a href={`mailto:${OFFICE.email}`} className="text-gold-400 underline underline-offset-4">
              {OFFICE.email}
            </a>
            .
          </p>
        </Section>

        <Section title="9. Alterações">
          <p>
            Esta política pode ser atualizada. A data da última versão aparece no início desta
            página.
          </p>
        </Section>
      </article>
    </main>
  );
}
